import "../static/bodyDescriptionCard.css";
import React from "react";

function BodyDescriptionCard() {
  return (
    <div className="bodyDescriptionCard pt-xl-7 pt-lg-7 pt-md-7 pt-sm-0 pt-0 pl-xl-7 pl-lg-7 pr-xl-7 pr-lg-7 pb-xl-5 pb-lg-5 mb-md-0">
      <div className="d-none d-md-block webView">
        <div className="d-flex flex-row ">
          <div className="row">
            <div className="descriptionImg1 col-custom-8 mr-2 mb-2">
              <h1 className="descriptionTitle1 m-auto col-10 pt-5">
                <div className="col-xl-10 col-lg-10 col-md-10 mr-auto">
                  New music of your favourite Artist
                </div>
              </h1>
              <div className="descriptionDetails1 mx-auto col-xl-10 col-lg-10 col-md-10">
                <div className="col-xl-10 col-lg-10 col-md-10 mr-auto">
                  {
                    "Never miss an event of your artist.  Find music videos, songs, and more"
                  }
                </div>
              </div>
            </div>
            <div className="descriptionImg2 col-custom-4">
              <h1 className="descriptionTitle1 m-auto col-xl-10 col-lg-10 col-md-10 pt-5">
                Music for every mood
              </h1>
              <div className="descriptionDetails2 col-xl-11 col-lg-11 col-md-11 px-0">
                Live Stream of your favourite genre & mood
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-none d-md-block">
        <div className=" d-flex flex-row ">
          <div className="row">
            <div className="descriptionImg3 col-custom-4 mr-2">
              <h1 className="descriptionTitle1 m-auto col-6 pt-lg-6 pt-xl-6 pt-md-6">
                Raw Organic Uncensored Music
              </h1>
            </div>
            <div className="descriptionImg4 col-custom-8">
              <h1 className="descriptionTitle1 mx-auto col-xl-10 col-lg-10 col-md-10 pt-5">
                Discover new artists at touch of your fingertips
              </h1>
              <div className="descriptionDetails1 mx-auto col-xl-10 col-lg-10 col-md-10">
                Thousands of talented artists on Ombre. Bollywood, techno,
                hip-hop and more.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-block d-md-none mobileView">
        <div className="descriptionImg1 col-12">
          <h1 className="descriptionTitleMobile1 col-10 ">
            Watch Live Streams of your favourite Artist
          </h1>
          <div className="descriptionDetailsMobile1 col-12 p-0">
            Discover the artists you love, only on Ombré
          </div>
        </div>
        <div className="d-flex flex-row">
          <div className="row m-0 mb-2">
            <div className=" descriptionImg2 col-6">
              <h1 className="descriptionTitleMobile2">Browse by Genre </h1>
              <div className="descriptionDetailsMobile2 mx-auto col-sm-10 col-10 p-0">
                Live Stream your favourite genre
              </div>
            </div>
            <div className="descriptionImg3 col-6">
              <h1 className="descriptionTitleMobile2">
                Raw Organic Uncensored Music
              </h1>
            </div>
          </div>
        </div>
        <div className="descriptionImg4 col-12 mb-2">
          <h1 className="descriptionTitleMobile1 col-10">
            Discover new Artists of the Genres you love
          </h1>
          <div className="descriptionDetailsMobile2 mx-auto col-sm-8 col-8">
            Discover new artists of the genre you love, only on Ombré
          </div>
        </div>
      </div>
      <div className="containerFluid mt-5 ">
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-7 col-7 mx-auto curatedContainer  ">
            <div className="curatedCenterImage"></div>
            <div className="curatedTopImage"></div>
            <div className="curatedLeftImage"></div>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-9 col-9 text-xl-start text-lg-start text-md-start  m-xl-auto m-lg-auto m-md-auto  mx-sm-auto  mt-sm-5  mx-auto mt-5 order-xl-1 order-lg-1 order-md-1  order-sm-2 order-2 p-0">
            <div className="curatedHeading col-xl-10 col-md-10 col-lg-10 p-0 ml-auto">
              Get Curated Content
            </div>
            <div className="curatedDescription  col-xl-10 col-md-9 col-lg-10 p-0 ml-auto">
              Ombre learns the preference of your music and brings to you the
              best content for all your music ravings !
            </div>
          </div>
        </div>
      </div>
      <div className="containerFluid mt-5 padding-bottom">
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-5 col-sm-9 col-9 text-xl-start text-lg-start text-md-start m-xl-auto m-lg-auto m-md-auto mx-sm-auto  mt-sm-5 mb-sm-5  mx-auto mt-5 mb-5 order-xl-1 order-lg-1 order-md-1 order-sm-2 order-2 p-0">
            <div className="curatedHeading col-xl-11 col-md-10 col-lg-11 col-sm-11 p-0 mx-auto">
              Find new Artists based on Genre
            </div>
            <div className="curatedDescription col-xl-11 col-md-11 col-lg-11 p-0 mx-auto">
              Discover new artists of your favourite genre and follow them on
              the app !
            </div>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-9 col-9 mx-auto mt-5 curatedContainer order-xl-2 order-lg-2 order-md-2 order-sm-1 order-1">
            <div className="curatedCenterImage2"></div>
            <div className="curatedTopImage2"></div>
            <div className="curatedLeftImage2 text-center">
              <div className="pt-lg-2 pt-xl-2 pt-md-2 py-sm-0 py-0">
                + Follow
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BodyDescriptionCard;



// WEBPACK FOOTER //
// ./src/pages/Home/components/BodyDescriptionCard.jsx